<template>
  <base-material-card
    :icon="icon"
    class="v-card--material-stats"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:after-heading>
      <div class="ml-auto text-right">
        <div
          class="body-3 grey--text font-weight-light"
          v-text="title"
        />

        <h3
          id="copy-code"
          class="text-h3 font-weight-light text--primary"
        >
          {{ value }}
        </h3>
      </div>
    </template>

    <v-col
      cols="12"
      class="px-0"
    >
      <v-divider />
    </v-col>

    <v-card-actions class="pa-0">
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            size="16"
            class="ml-2 mr-1"
            @click="copyToClipboard"
            v-on="on"
          >
            mdi-content-copy
          </v-icon>
        </template>
        <span>Copiar</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            size="16"
            class="ml-2 mr-1"
            v-bind="attrs"
            v-on="on"
          >
            mdi-information-outline
          </v-icon>
        </template>
        <span>Comparte este código y cada mes recibirás descuentos hasta del 10% del plan de tu referido</span>
      </v-tooltip>
    </v-card-actions>
  </base-material-card>
</template>

<script>
  import Card from '@/components/base/Card'
  import * as vars from '@/vars.json'

  export default {
    name: 'ReferralsCard',

    inheritAttrs: false,
    props: {
      ...Card.props,
      icon: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        default: undefined,
      },
      value: {
        type: String,
        default: undefined,
      },
    },
    methods: {
      copyToClipboard () {
        const codeToCopy = document.getElementById('copy-code')
        const text = codeToCopy.textContent
        navigator.clipboard.writeText(vars.domain2.redirection + 'pages/register/' + text.split(' ')[1])
      },
    },

  }
</script>

<style lang="sass">
.v-card--material-stats
  display: flex
  flex-wrap: wrap
  position: relative

  > div:first-child
    justify-content: space-between

  .v-card
    border-radius: 4px
    flex: 0 1 auto

  .v-card__text
    display: inline-block
    flex: 1 0 calc(100% - 120px)
    position: absolute
    top: 0
    right: 0
    width: 100%

  .v-card__actions
    flex: 1 0 100%
</style>
